<script lang="ts">
  import { subscriptionStore } from '$lib/stores/subscription';

  interface Props {
    details?: string;
  }

  let { details = '' }: Props = $props();

  // Parse details for feature-specific info
  let featureInfo = $state({ feature: 'AI', used: 0, limit: 10, remaining: 0 });

  $effect(() => {
    if (details) {
      try {
        const parsed = JSON.parse(details);
        featureInfo = {
          feature: getFeatureName(parsed.feature || 'AI'),
          used: parsed.used || 0,
          limit: parsed.limit || 10,
          remaining: parsed.remaining || 0
        };
      } catch {
        // Fallback to default
        featureInfo = { feature: 'AI', used: 0, limit: 10, remaining: 0 };
      }
    }
  });

  function getFeatureName(feature: string): string {
    const names: Record<string, string> = {
      paraphrase: '다시쓰기',
      expand: '확장',
      shrink: '축약',
      summarize: '요약',
      continue: '이어쓰기',
      critic: '비평',
      generate: '생성'
    };
    return names[feature] || 'AI 기능';
  }

  let tier = $derived($subscriptionStore.type);
  let upgradeTier = $derived(tier === 'free' ? '프리미엄' : '프리미엄');
  let upgradeLimit = $derived(tier === 'free' ? 2000 : 2000);
</script>

<div class="prompt-content">
  <p>오늘의 {featureInfo.feature} 사용 한도에 도달했습니다.</p>
  <div class="usage-stats">
    <div class="stat exceeded">
      <span class="stat-label">{featureInfo.feature}</span>
      <span class="stat-value">{featureInfo.used}/{featureInfo.limit}회</span>
    </div>
    <div class="stat">
      <span class="stat-label">남은 횟수</span>
      <span class="stat-value">{featureInfo.remaining}회</span>
    </div>
  </div>

  <div class="upgrade-benefits">
    <p class="upgrade-title">{upgradeTier}로 업그레이드하면:</p>
    <ul>
      <li>AI 기능 일일 <strong>{upgradeLimit}회</strong> 사용</li>
      <li>더 빠른 응답 속도</li>
      <li>우선 처리</li>
    </ul>
  </div>

  <p class="reset-info">한국 시간 자정에 사용 횟수가 초기화됩니다.</p>
</div>

<style>
  .prompt-content p {
    margin: 0 0 8px 0;
    color: var(--text-secondary);
    font-size: 13px;
    line-height: 1.5;
  }

  .usage-stats {
    display: flex;
    gap: 20px;
    background: var(--bg-secondary);
    border: 1px solid var(--border-primary);
    border-radius: 8px;
    padding: 12px 16px;
    margin: 12px 0;
  }

  .stat {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .stat-label {
    font-size: 12px;
    font-weight: 500;
    color: var(--text-secondary);
  }

  .stat-value {
    font-size: 12px;
    font-weight: 600;
    color: var(--text-primary);
  }

  .stat.exceeded .stat-value {
    color: var(--error);
  }

  .upgrade-benefits {
    background: linear-gradient(135deg, rgba(139, 92, 246, 0.05), rgba(99, 102, 241, 0.05));
    border: 1px solid rgba(139, 92, 246, 0.2);
    border-radius: 8px;
    padding: 12px;
    margin: 12px 0;
  }

  .upgrade-title {
    font-size: 12px;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 8px;
  }

  .upgrade-benefits ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .upgrade-benefits li {
    font-size: 12px;
    color: var(--text-secondary);
    padding: 4px 0;
    padding-left: 20px;
    position: relative;
  }

  .upgrade-benefits li::before {
    content: '✓';
    position: absolute;
    left: 0;
    color: #8b5cf6;
    font-weight: bold;
  }

  .upgrade-benefits strong {
    color: #8b5cf6;
    font-weight: 600;
  }

  .reset-info {
    font-size: 11px;
    color: var(--text-tertiary);
    margin-top: 8px;
  }
</style>